<template>
  <div>
    <BaseHeadline icon="mdi-briefcase-variant">
      <template v-slot:headlineBtns>
        <ChangeActiveContactDialog />

        <v-btn
          v-if="isMainContactPerson"
          color="primary"
          depressed
          @click="addContact"
        >
          <v-icon left>mdi-plus</v-icon>
          Legg til ansatt
        </v-btn>
      </template>
    </BaseHeadline>

    <ChangeActiveContactDialog v-if="$vuetify.breakpoint.xs" block />

    <BaseView v-model="list">
      <template v-slot="{ element }">
        <CompanyCard v-if="element.type === 'CompanyCard'" />
        <CompanyContacts
          ref="companyContacts"
          v-if="element.type === 'CompanyContacts'"
        />
      </template>
    </BaseView>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";
import CompanyCard from "@/components/company/CompanyCard.vue";
import CompanyContacts from "@/components/company/CompanyContacts.vue";
import ChangeActiveContactDialog from "@/components/company/children/ChangeActiveContactDialog.vue";

export default Vue.extend({
  data() {
    return {
      list: {
        lg: [[{ type: "CompanyCard" }], [{ type: "CompanyContacts" }]],
        md: [[{ type: "CompanyCard" }], [{ type: "CompanyContacts" }]],
        sm: [[{ type: "CompanyCard" }], [{ type: "CompanyContacts" }]],
        xs: [[{ type: "CompanyCard" }, { type: "CompanyContacts" }]],
      },
    };
  },
  methods: {
    addContact() {
      this.companyContacts.addContact();
    },
  },
  computed: {
    ...mapGetters({
      isMainContactPerson: "shared/isMainContactPerson",
    }),
    companyContacts(): Vue & {
      addContact: () => boolean;
    } {
      return this.$refs.companyContacts as Vue & {
        addContact: () => boolean;
      };
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    CompanyCard,
    CompanyContacts,
    ChangeActiveContactDialog,
  },
});
</script>
